<template>
  <div style="margin-top:10px;">
    <el-row align="bottom">
      <el-col :span="20">
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
          :page-size="pagesize" layout="prev,pager,next" :total="pageTotal">
        </el-pagination>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" size="mini" @click="mergePayOrders" icon="el-icon-s-finance">合并付款</el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" size="mini" @click="batchCancelOrders" icon="el-icon-s-finance">批量取消</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" @expand-change="tableChange" :expand-row-keys="expands" row-key="id" stripe border
      ref="multipleTable" @selection-change="selectionChange">
      <el-table-column type="expand" prop="childdata" size="small">
        <span slot-scope="scopes">
          <!-- <el-table :data="scopes.row.orderProductList" border align="center" stripe> -->
          <el-table :data="orderProductListMap[scopes.row.id]" border align="center" stripe>
            <el-table-column prop="warehouseUserName" label="供应商" width="200">
              <span slot-scope="scope">
                {{ scope.row.warehouseUserName }}
              </span>
            </el-table-column>
            <el-table-column prop="productName" label="图书名称" />
            <el-table-column prop="productSn" label="ISBN" width="200" />
            <el-table-column prop="marketPrice" label="定价" width="90" />
            <el-table-column prop="discount" label="折扣" width="90" />
            <el-table-column prop="shopPriceTotal" label="折扣价" width="90" />
            <el-table-column prop="productNumber" label="数量" width="90" />
            <el-table-column prop="productAssigned" label="已配送" width="90">
            </el-table-column>
          </el-table>
          <div>
            <el-tag type="info" effect="plain">
              <b>收货人</b>：{{ scopes.row.consignee }}&#8195; <b>收货地址</b>：
              {{ scopes.row.provinceText }}
              {{ scopes.row.cityText }}
              {{ scopes.row.districtText }}&#8195;
              {{ scopes.row.address }}&#8195; <b>联系电话</b>：{{
              scopes.row.mobile
              }}&#8195;
            </el-tag>
          </div>
          <div>
            <el-tag type="info" effect="plain">
              <b>客户下单备注</b>：{{ scopes.row.payNote }}
            </el-tag>
          </div>
          <div>
            <el-tag type="info" effect="plain">
              <b>系统订单备注</b>：{{ scopes.row.remark }}
            </el-tag>
          </div>
          <div>
            <el-tag type="info" effect="plain">
              <b>包标</b>：{{ scopes.row.labelNote }}
            </el-tag>
          </div>
        </span>
      </el-table-column>
      <el-table-column align="center" label="全选" type="selection" width="55">
      </el-table-column>
      <el-table-column align="center" label="订单编号">
        <template slot-scope="scope">
          <el-link :underline="false" @click="mergePayOrder(scope.row)">{{
            scope.row.orderSn
            }}</el-link>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="goodsAmount" label="数量" width="60"></el-table-column>
      <el-table-column align="center" prop="orderMoneyOriginal" width="65" label="定价">
      </el-table-column>
      <el-table-column align="center" prop="orderMoney" label="折扣价" width="70"></el-table-column>
      <el-table-column align="center" prop="expenses" label="运费" width="65"></el-table-column>
      <el-table-column align="center" prop="addTime" label="订单时间">
      </el-table-column>
      <el-table-column align="center" prop="orderStatus_dictText" label="订单状态" width="90"></el-table-column>
      <el-table-column align="center" prop="shippingStatus_dictText" label="发货状态" width="90"></el-table-column>
      <el-table-column align="center" label="付款状态" prop="payStatus_dictText" width="90">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <!-- <el-link
            :underline="false"
            @click="mergePayOrder(scope.row)"
            type="primary"
            >退货</el-link
          >
          <el-divider direction="vertical"></el-divider>
          <el-link
            :underline="false"
            @click="cancelOrder(scope.row)"
            type="danger"
            >退款</el-link
          > -->
          <el-tooltip class="item" effect="light" content="付款" placement="top">
            <el-button size="mini" type="primary" round @click="mergePayOrder(scope.row)">付款</el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="取消订单" placement="top">
            <el-button size="mini" type="primary" round @click="cancelOrder(scope.row)">取消订单</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAction, downFile } from "../../../api/index";
export default {
  name: "orderNoPay",
  inject: ['parentQueryParam'],
  data() {
    return {
      tableData: [],
      expands: [],
      multipleSelection: [],
      orderProductArr: [],
      orderProductListMap:{},
      queryParam: {
        isbn: "",
        orderSn: "",
        beginTime: "",
        endTime: "",
      },
      url: {
        getorderLit: "/order/queryList",
        selectOrderProductByOrderId: "/order/selectOrderProductByOrderId",
        cancelOrder: "/order/cancelOrder",
        batchCancelOrders: "/order/batchCancelOrders",
        exportExcel: "/order/exportExcel",
        mergePayOrder: "/order/mergePayOrder",
      },
      currentPage: 1, // 当前页码
      pagesize: 10, // 每页显示的行数
      pageTotal: 0,
      dialogshow: false,
      orderList: [],
      orderStatus: "3",
    };
  },
  computed: {
    ...mapGetters(["isNaName"]),
  },
  mounted() {},
  created() {
    this.getOrderList(1);
  },
  methods: {
    getOrderList(page, isbn, orderSn, beginTime, endTime, consignee, tel, haveRemarkFlag) {
      getAction(this.url.getorderLit, {
        pageNo: page,
        payStatus: 1,
        orderStatus: 0,
        userId: this.$store.state.userInfo.id,
        isbn: isbn,
        orderSn: orderSn,
        createTime_begin: beginTime,
        createTime_end: endTime,
        consignee: consignee,
        tel: tel,
        haveRemarkFlag: haveRemarkFlag,
      }).then((res) => {
        if (res.data.success) {
          this.orderProductListMap = res.data.result.orderProductListMap;
          this.tableData = res.data.result.orderListPage.records;
          this.pageTotal = res.data.result.orderListPage.total;
          this.expands = res.data.result.expands;
          // this.tableData = res.data.result.records;
          // this.pageTotal = res.data.result.total;
        }
      });
    },
    onOpenOrderRowInfo(f){
      const that = this
      if(f){
        that.tableData.forEach((row) => {
          let id = row.id;
          that.expands.push(id);
          that.getOrderProduct(id)
        });
      }
    },
    tableChange(row) {
      //订单展开，查询订单里的产品信息
      var that = this;
      // if (expandedRows.length) {
      //   that.expands = [];
      //   if (row) {
      //     that.expands.push(row.id); // 每次push进去的是每行的ID
      //   }
      // } else {
      //   that.expands = []; // 默认不展开
      // }
      if (!that.orderProductListMap[row.id]){
        that.expands.push(row.id); // 每次push进去的是每行的ID
      }
      that.getOrderProduct(row.id)
    },
    getOrderProduct(id){
      const that = this
      getAction(that.url.selectOrderProductByOrderId, {
        id: id, 'productSn': that.parentQueryParam.isbn,
        userId: this.$store.state.userInfo.id }).then(
        (res) => {
          if (res.data.success) {
            that.orderProductArr = res.data.result;
            that.orderProductListMap[id] = res.data.result;
            that.$forceUpdate();
          }
        }
      );
    },
    loadList(pageNo){ // 第几页
      let isbn = this.parentQueryParam.isbn;
      let orderSn = this.parentQueryParam.orderSn;
      let createTime_begin = this.parentQueryParam.beginTime;
      let createTime_end = this.parentQueryParam.endTime;
      let consignee = this.parentQueryParam.consignee;
      let tel = this.parentQueryParam.tel;
      let haveRemarkFlag = this.parentQueryParam.haveRemarkFlag;
      this.getOrderList(pageNo, isbn, orderSn, createTime_begin, createTime_end, consignee, tel, haveRemarkFlag);
    },
    // 页面切换方法
    handleCurrentChange(val) {
      this.loadList(val);
      this.currentPage = val;
    },
    selectionChange(row) {
      // console.log("selectionChange========",row);
      this.multipleSelection = row;
      this.$emit('selectionChange',this.multipleSelection)
    },
    cancelOrder(row) {
      console.log("selectionChange========",row);
      // if(this.multipleSelection.length == 0){
      //   this.$message.warning("未选择需要处理的订单");
      //   return;
      // }
      this.$confirm("取消此订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getAction(this.url.cancelOrder, { id: row.id }).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "订单已取消！",
              });
              this.loadList(1);
            }
          });
        })
        .catch(() => {});
    },
    batchCancelOrders() {
      if(this.multipleSelection.length == 0){
        this.$message.warning("未选择需要处理的订单");
        return;
      }
      this.$confirm("取消已选中的订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = ''
          this.multipleSelection.forEach(item => {
            if(ids == ''){
              ids = item.id;
            }else{
              ids = ids + ',' + item.id;
            }
          });
          getAction(this.url.batchCancelOrders, { ids: ids }).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "订单已取消！",
              });
              this.loadList(1);
            }
          });
        })
        .catch(() => {});
    },
    mergePayOrders() {
      this.orderList = [];
      if (this.multipleSelection.length < 1) {
        this.$message.error("请先选中要合并支付的订单再操作！");
        return;
      }
      this.orderList = this.multipleSelection;
      this.$router.push({
        path: "/orderDetial",
        params: {
          orderList: this.orderList,
          orderStatus: 3,
        },
        name: "订单明细",
      });
    },
    mergePayOrder(obj) {
      this.orderList = [];
      this.orderList.push(obj);

      this.$router.push({
        path: "/orderDetial",
        params: {
          orderList: this.orderList,
          orderStatus: 3,
        },
        name: "订单明细",
      });
    },
    handleClose() {
      this.dialogshow = false;
    },
    exportExcel() {
      let fileName = "京麦通订单";
      downFile(this.url.exportExcel, {
        userId: this.$store.state.userInfo.id,
      }).then((data) => {
        if (!data) {
          this.$message.warning("文件下载失败");
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(
            new Blob([data], { type: "application/vnd.ms-excel" }),
            fileName + ".xls"
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: "application/vnd.ms-excel" })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName + ".xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>


/*2.展开按钮未点击的样式是加号带边框*/
::v-deep .el-table__expand-icon .el-icon-arrow-right:before {
  color: #000;
  font-size: 18px;
}


$mainColor: #5cadff;
.contentTitle {
  h1 {
    font-weight: normal;
    font-size: 30px;
    color: #757575;
  }
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  line-height: 36px;
  background: #e5e9f2;
}
.demo-form-inline {
  margin-top: 1%;
}
// .el-col-2{
//     text-align: right !important;
// }
.el-divider {
  margin: 7px 0 !important;
}
.option {
  ul.category {
    float: left;
    height: 22px;
    padding: 10px 0;
    li {
      float: left;
      a {
        font-size: 16px;
        color: #757575;
        &:hover {
          color: $mainColor;
        }
      }
      span {
        margin: 0 20px;
      }
      &:last-child {
        span {
          display: none;
        }
      }
      &.active {
        a {
          color: $mainColor;
        }
      }
    }
  }
}
.header-search {
  float: right;
  form {
    position: relative;
    .searchPart {
      float: left;
      width: 245px;
      height: 50px;
      transition: all linear 0.2s 0s;
      border: 1px solid #e0e0e0;
      border-right: 0;
      box-sizing: border-box;
      input {
        width: calc(100% - 10px);
        height: 100%;
        outline: none;
        padding: 0 0 0 10px;
        &::-webkit-input-placeholder {
          color: #757575;
        }
      }
    }
    &:hover {
      .searchPart {
        border-color: #b0b0b0;
      }
      .sumbitPart {
        button {
          border-color: #b0b0b0;
        }
      }
    }
    .sumbitPart {
      float: left;
      button {
        cursor: pointer;
        width: 50px;
        height: 50px;
        border: 1px solid #e0e0e0;
        box-sizing: border-box;
        background-color: #fff;
        transition: all linear 0.2s 0s;
        span {
          color: #616161;
          font-size: 20px;
        }
      }
      &:hover {
        button {
          background-color: $mainColor;
          border: 1px solid $mainColor;
          span {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
